module.exports = __webpack_public_path__ + "static/media/ic_place_24px.7147dc6e.svg";